import { useState, useEffect } from 'react';
import OrderService from './CompanyOrderService';

const useManageCompanyOrder = () => {
  const [orders, setOrder] = useState([])
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(null);

  const addOrderManual = async (id, formData) => {
    let result = true
    setIsLoading(true);
    try {
      const response = await OrderService.addOrderManual(id, formData);
      console.log(response)
      setError(null);
    } catch (err) {
        setError(err);
        result = err.message
    } finally {
        setIsLoading(false);
        return result
    }
  };

  const getCompanyOrder = async (month) => {
    setIsLoading(true);
    try {
      const response = await OrderService.getCompanyOrder(month);
      console.log(response.data)
      setError(null);
      setOrder(response.data)
      return response.data
    } catch (err) {
      console.log(err)
      setError(err);
    } finally {
        setIsLoading(false);
    }
  };

  const getCompanyOrderDetailByOrder = async (orderId) => {
    setIsLoading(true);
    try {
      const response = await OrderService.getCompanyOrderDetailByOrder(orderId);
      setError(null);
      return response.data
    } catch (err) {
      console.log(err)
      setError(err);
    } finally {
        setIsLoading(false);
    }
  };

  const deleteCompanyOrder = async (orderId) => {
    setIsLoading(true);
    let result = true
    try {
        await OrderService.deleteCompanyOrder(orderId);
    } catch (err) {
      result = false
      console.log(err)
      setError(err);
    } finally {
      setIsLoading(false);
      return result
    }
  };

  return { 
    orders,
    addOrderManual,
    getCompanyOrder,
    getCompanyOrderDetailByOrder,
    deleteCompanyOrder
  };
}

export default useManageCompanyOrder;
